export const COMPANY = {
  name: "Atlas Security & Life Safety",
  shortName: "ATLAS",
  tagline: "Complete Protection. One Trusted Partner.",
  phone: "931-633-9386",
  phoneHref: "tel:+19316339386",
  email: "info@atlassecuritylifesafety.net",
  serviceArea: "Nashville, Tennessee & surrounding areas",
  logo: "/atlas-logo.png",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Why Atlas", href: "#why-atlas" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    id: "cctv",
    title: "CCTV & Video Surveillance",
    tagline: "4K Ultra-HD AI-assisted optical & thermal monitoring",
    description:
      "Protect every corner of your property with high-resolution cameras, remote mobile viewing, and intelligent motion analytics that alert you the moment something matters.",
    features: ["Remote Mobile Access", "AI Motion Analytics", "Night Vision & Thermal", "Cloud & NVR Recording"],
    useCases: "Retail storefronts, warehouses, offices, residential properties.",
    image:
      "https://images.unsplash.com/photo-1589935447067-5531094415d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxzZWN1cml0eSUyMGNjdHYlMjBjYW1lcmElMjBzdXJ2ZWlsbGFuY2UlMjBzeXN0ZW18ZW58MHx8fHwxNzkyMzUzNjA2fDA&ixlib=rb-4.1.0&q=85",
    icon: "Camera",
  },
  {
    id: "access_control",
    title: "Access Control Systems",
    tagline: "Biometric, RFID & mobile keyless door security",
    description:
      "Control exactly who goes where, and when. From keycards to biometric scanners and cloud-managed door schedules, Atlas keeps unauthorized people out.",
    features: ["Keycard & Keyfob Access", "Biometric Scanners", "Cloud Portal Control", "Visitor Management"],
    useCases: "Corporate offices, multi-tenant buildings, data rooms, gated facilities.",
    image:
      "https://images.pexels.com/photos/37538043/pexels-photo-37538043.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "KeyRound",
  },
  {
    id: "intrusion",
    title: "Intrusion Detection",
    tagline: "Perimeter guard & high-sensitivity alarm shields",
    description:
      "Layered sensors detect break-ins before they happen and dispatch help instantly. Glass-break, motion, and door/window sensors monitored 24/7.",
    features: ["Glass Break Sensors", "Motion Detection", "Instant Dispatch Alerts", "24/7 Monitoring Station"],
    useCases: "Homes, small businesses, storage facilities, vacant properties.",
    image:
      "https://images.pexels.com/photos/7522609/pexels-photo-7522609.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "ShieldAlert",
  },
  {
    id: "fire_alarms",
    title: "Fire Alarms & Life Safety",
    tagline: "NFPA code-compliant smoke, heat & CO systems",
    description:
      "Code-compliant fire and life-safety systems that protect people first. Designed, installed, and inspected to keep you compliant and covered.",
    features: ["NFPA 72 Compliance", "Smoke & CO Detectors", "Central Station Dispatch", "Annual Inspection Logs"],
    useCases: "Commercial buildings, restaurants, apartments, mixed-use facilities.",
    image:
      "https://images.unsplash.com/photo-1653353436174-a8e724190fd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxmaXJlJTIwYWxhcm0lMjBzeXN0ZW18ZW58MHx8fHwxNzkyMzUzNjA3fDA&ixlib=rb-4.1.0&q=85",
    icon: "Flame",
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);

export const PROPERTY_TYPES = ["Commercial", "Residential", "Industrial / Warehouse", "Multi-Tenant / Apartment", "Retail", "Other"];

export const PROCESS_STEPS = [
  { step: "01", name: "Free On-Site Survey", desc: "A comprehensive security & compliance audit of your premises, at no cost." },
  { step: "02", name: "Custom System Design", desc: "Tailored blueprints and a transparent, fixed-price proposal." },
  { step: "03", name: "Precision Installation", desc: "Certified technicians handle wiring, setup, and full staff training." },
  { step: "04", name: "24/7 Active Monitoring", desc: "Continuous protection with immediate emergency dispatch response." },
];

export const TRUST_BADGES = [
  "Licensed & State Certified",
  "Insured & Bonded",
  "24/7 Central Monitoring",
  "100% Turnkey Installation",
];

export const HERO_IMAGE =
  "https://images.pexels.com/photos/30692441/pexels-photo-30692441.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const MONITORING_IMAGE =
  "https://images.unsplash.com/photo-1708807472445-d33589e6b090?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxzZWN1cml0eSUyMG1vbml0b3JpbmclMjBjb250cm9sJTIwcm9vbSUyMHN1cnZlaWxsYW5jZSUyMG1vbml0b3JzfGVufDB8fHx8MTc5MjM1MzYxMHww&ixlib=rb-4.1.0&q=85";
